import { Locale } from "vant";
import enUS from "vant/lib/locale/lang/en-US";
import zhCN from "vant/lib/locale/lang/zh-CN";
import zhHK from "vant/lib/locale/lang/zh-HK";
export function Local(lang) {
  if (lang == "zh-HK") {
    Locale.use("zh-HK", zhHK);
  } else if (lang == "en") {
    Locale.use("en", enUS);
  } else {
    Locale.use("zh-CN", zhCN);
  }
}
